<template>
  <div class="relative w-full max-w-sm mx-auto">
    <img :src="src" :alt="alt" @click="showPreview = true"
      class="cursor-pointer rounded h-72  w-full object-cover" />

    <div v-if="showPreview" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-30"
      @click.self="showPreview = false">
      <div class="absolute max-w-2xl w-full p-4 ">
        <img ref="imageRef" :src="src" :alt="alt" class="rounded-2xl w-full h-full object-contain transform"
          :style="{ transform: `scale(${scale})`, rotate: `rotatat` }" />
      </div>
      <div class=" absolute bottom-20 left-1/2 flex space-x-5  bg-gray-800 rounded-xl p-2  ">
        <div class=" text-white hover:bg-gray-700 p-2 rounded-lg" @click="zoomOut">
          <i class="las la-search-minus"></i>
        </div>
        <div class=" text-white hover:bg-gray-700 p-2 rounded-lg" @click="zoomIn">
          <i class="las la-search-plus"></i>
        </div>
        <!-- <div class=" text-white  hover:bg-gray-700 p-2 rounded-lg" @click="rotateleft">
          <i class="las la-undo"></i>
        </div>
        <div class=" text-white  hover:bg-gray-700 p-2 rounded-lg" @click="rotateright">
          <i class="las la-redo"></i>
        </div> -->
      </div>
      <button @click="showPreview = false"
        class="absolute top-4 right-4 text-white bg-gray-800 hover:bg-gray-700 p-2 rounded-full">
        <i class="las la-times"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: 'Image',
  },
});

const showPreview = ref(false);
const scale = ref(1);
const imageRef = ref(null);

const zoomIn = () => {
  scale.value = Math.min(scale.value + 0.1, 2);
};

const zoomOut = () => {
  scale.value = Math.max(scale.value - 0.1, 1);
};
// const rotateleft = () => {
//   imageRef.value.style.transform = 'rotate(-90deg)';
// };
// const rotateright = () => {
//   imageRef.value.style.transform = 'rotate(90deg)';
// };

</script>

<style scoped>
body.modal-open {
  overflow: hidden;
}
</style>
